export function LinkSoft({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.4917 14.5833H13.75C16.2667 14.5833 18.3333 12.525 18.3333 10C18.3333 7.48333 16.275 5.41667 13.75 5.41667H12.4917"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5.41667H6.25C3.725 5.41667 1.66666 7.475 1.66666 10C1.66666 12.5167 3.725 14.5833 6.25 14.5833H7.5"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66666 10H13.3333"
        stroke="black"
        strokeOpacity="0.54"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
